import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/',
      children: [
        {
          path: '/',
          component: (resolve) => require(['@/views/home'], resolve),
          name: 'index',
          meta: { title: '首页', icon: 'dashboard', affix: true }
        },
        {
          path: '/introduction',
          component: (resolve) => require(['@/views/introduction'], resolve),
          name: 'index',
          meta: { title: '大赛介绍', icon: 'dashboard', affix: true }
        },
        {
          path: '/dynamic',
          component: (resolve) => require(['@/views/dynamic'], resolve),
          name: 'index',
          meta: { title: '赛事动态', icon: 'dashboard', affix: true }
        },
        {
          path: '/scoreQuery',
          component: (resolve) => require(['@/views/scoreQuery'], resolve),
          name: 'index',
          meta: { title: '成绩查询', icon: 'dashboard', affix: true }
        },
        {
          path: '/scoreQueryMove',
          component: (resolve) => require(['@/views/scoreQueryMove'], resolve),
          name: 'index',
          meta: { title: '移动端成绩查询', icon: 'dashboard', affix: true }
        },
        {
          path: '/certificateQuery',
          component: (resolve) => require(['@/views/scoreQuery'], resolve),
          name: 'index',
          meta: { title: '证书查询', icon: 'dashboard', affix: true }
        },
        // {
        //   path: '/signUp',
        //   component: (resolve) => require(['@/views/signUp'], resolve),
        //   name: 'index',
        //   meta: { title: '报名中心登录', icon: 'dashboard', affix: true },
        // },
        {
          path: '/personal',
          component: (resolve) => require(['@/views/personal'], resolve),
          name: 'index',
          meta: { title: '注册', icon: 'dashboard', affix: true },
        },
        {
          path: '/password',
          component: (resolve) => require(['@/views/password'], resolve),
          name: 'index',
          meta: { title: '找回密码', icon: 'dashboard', affix: true },
        },
        {
          path: '/registrationCenter',
          component: (resolve) => require(['@/views/registrationCenter'], resolve),
          name: 'index',
          meta: { title: '报名信息', icon: 'dashboard', affix: true },
        },
        {
          path: '/information',
          component: (resolve) => require(['@/views/information'], resolve),
          name: 'index',
          meta: { title: '报名信息', icon: 'dashboard', affix: true },
        },
        {
          path: '/preliminaryWorks',
          component: (resolve) => require(['@/views/preliminaryWorks'], resolve),
          name: 'index',
          meta: { title: '初赛作品', icon: 'dashboard', affix: true },
        },
        {
          path: '/memberInformation',
          component: (resolve) => require(['@/views/memberInformation'], resolve),
          name: 'index',
          meta: { title: '成员信息', icon: 'dashboard', affix: true },
        },
        {
          path: '/changePassword',
          component: (resolve) => require(['@/views/changePassword'], resolve),
          name: 'index',
          meta: { title: '修改密码', icon: 'dashboard', affix: true },
        },
        {
          path: '/inviteMembers',
          component: (resolve) => require(['@/views/inviteMembers'], resolve),
          name: 'index',
          meta: { title: '邀请成员', icon: 'dashboard', affix: true },
        },
        {
          path: '/contact',
          component: (resolve) => require(['@/views/contact'], resolve),
          name: 'index',
          meta: { title: '联系我们', icon: 'dashboard', affix: true },
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js